import React, { useState } from 'react';
import classnames from 'classnames';
import Text from '../../../global/text/text';

import './_oe-staff-filter-dropdown.scss';

interface IProps {
    entityName: string;
    isListLoading: boolean;
    oeStaffFilter: boolean;
    onChangeFilter: (value: boolean) => void;
}

const OeStaffFilterDropdown = (props: IProps) => {
    const [isOpen, setIsOpen] = useState(false);

    const {
        entityName,
        isListLoading,
        oeStaffFilter,
        onChangeFilter,
    } = props;

    const isFilterActive = oeStaffFilter !== null;

    const filterItems = [
        {
            id: 'oe.common.yes',
            title: 'Yes',
            value: true,
        },
        {
            id: 'oe.common.no',
            title: 'No',
            value: false,
        }
    ];

    return (
        <div
            className='oestaff-filter-dropdown multi-selection-dropdown'
        >
            <div
                onClick={() => setIsOpen(prev => !prev)}
                className={classnames('cell-header-btn', {
                    'cell-header-btn--active': isOpen || isFilterActive
                })}
            >
                <Text message={entityName} withEllipsis />
            </div>

            {isOpen &&
            <>
                <div className='multi-selection-dropdown__overlay' onClick={() => setIsOpen(false)}/>
                <div className='oestaff-filter-dropdown__options multi-selection-dropdown__options'>
                    {
                        filterItems.map((item, index) => (
                            <div
                                key={index}
                                className={classnames('multi-select__option', {
                                    'multi-select__option--selected': item.value === oeStaffFilter,
                                })}
                                onClick={() => !isListLoading ? onChangeFilter(item.value) : undefined}
                            >
                                <Text id={item.id} message={item.title} withEllipsis/>
                            </div>
                        ))
                    }
                </div>
            </>
            }
        </div>
    );
};

export default OeStaffFilterDropdown;
